import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const types = {
  SET_USER: 'SET_USER', // 用户信息
  SET_LOGINSTAIE: 'SET_LOGINSTAIE', // 是否显示登陆
  SET_CHATIMG:'SET_CHATIMG'
}

const state = { 
  user: {} ,// 存储用户信息
  loginStaie:{}, 
  chatImg:''
}

const getters = {
  user: state => state.user,
  loginStaie: state => state.loginStaie,
  chatImg: state => state.chatImg
}

const mutations = {
  [types.SET_USER](state, user) {
    if (user)
      state.user = user
    else
      state.user = {}
  },
  [types.SET_CHATIMG](state, chatImg) {
    if (chatImg)
      state.chatImg = chatImg
    else
      state.chatImg =''
  },
  [types.SET_LOGINSTAIE](state,loginStaie) {
    if (loginStaie)
      state.loginStaie = loginStaie
    else
      state.loginStaie = {}
  }
}

const actions = {
  setChatImg: ({ commit }, chatImg) => {
    commit(types.SET_CHATIMG, chatImg)
  },
  setUser: ({ commit }, user) => {
    commit(types.SET_USER, user)
  },
  clearCurrentState: ({ commit }) => {
    commit(types.SET_USER, null)
  },
  loginState: ({ commit },loginStaie) => {
    commit(types.SET_LOGINSTAIE,loginStaie)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
